<template>
  <div class="nd-sidebar collapse show">
    <div class="nd-client-logo"></div>
    <SoftwareSelector></SoftwareSelector>
    <ul class="nd-primary-nav" @click="menuContainerClick">
      <li class="nd-sub-menu">
        <a href="#submenu-trackers" class="collapsed" data-bs-toggle="collapse" title="Trackers" aria-expanded="false">
          <i class="nd-toggle-sub ui-sidebar-children-toggle icon-chevron-down"></i>
          <i class="icon-fire"></i>
          <i class="nd-nav-arrow"></i>
          <span>Trackers</span>
        </a>
        <ul id="submenu-trackers">
          <li>
            <NuxtLink to="/trackers" title="Manage trackers">
              <span>Manage trackers</span>
            </NuxtLink>
          </li>
        </ul>
      </li>
      <li class="nd-sub-menu">
        <a href="#submenu-general" class="collapsed" data-bs-toggle="collapse" title="General Settings" aria-expanded="false">
          <i class="nd-toggle-sub ui-sidebar-children-toggle icon-chevron-down"></i>
          <i class="icon-cog"></i>
          <i class="nd-nav-arrow"></i>
          <span>General Settings</span>
        </a>
        <ul id="submenu-general">
          <li v-if="isAutoSoftwareSelected">
            <NuxtLink to="/templates" title="Template Management">
              <span>Template Management</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/dropcode-generator" title="Dropcode Generator">
              <span>Dropcode Generator</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/software" title="Software Management">
              <span>Software Management</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/standalone-snowplow" title="Standalone Snowplow Tester">
              <span>Standalone Snowplow Tester</span>
            </NuxtLink>
          </li>
        </ul>
      </li>
      <li class="nd-sub-menu">
        <a href="#submenu-plans" class="collapsed" data-bs-toggle="collapse" title="Tagging Planner" aria-expanded="false">
          <i class="nd-toggle-sub ui-sidebar-children-toggle icon-chevron-down"></i>
          <i class="icon-briefcase"></i>
          <i class="nd-nav-arrow"></i>
          <span>Tagging Planner</span>
        </a>
        <ul id="submenu-plans">
          <li>
            <NuxtLink to="/tagging-docs" title="Tagging Docs">
              <span>Tagging Docs</span>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/plan-management" title="Plan Management">
              <span>Plan Management</span>
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </div>

</template>

<script lang="ts">
import SoftwareSelector from "~/components/SoftwareSelector.vue";
import SoftwareHelper from '~/helpers/SoftwareHelper';
import SelectedGroupHashChangeDispatcher from '~/windowEvents/SelectedGroupHashChangeDispatcher';
import SelectedSoftwareChangeDispatcher from '~/windowEvents/SelectedSoftwareChangeDispatcher';

export default {
  name: "Sidebar",
  components: {
    SoftwareSelector,
  },
  data() {
    return {
      isAutoSoftwareSelected: true,
    }
  },
  methods: {
    setIsAutoSoftwareIsSelected() {
      const selectedSoftware = SoftwareHelper.getSelectedSoftwareObject();
      if (SoftwareHelper.validateSoftware(selectedSoftware)) {
        this.isAutoSoftwareSelected = SoftwareHelper.isAutoV10(selectedSoftware);
      }
    },
    menuContainerClick() {
      if (document.body.classList.contains('nd-sidebar-closed')) {
        document.body.classList.remove('nd-sidebar-closed');
      }
    }
  },
  async beforeMount() {
    window.addEventListener(SelectedGroupHashChangeDispatcher.EVENT_TYPE, this.setIsAutoSoftwareIsSelected);
    window.addEventListener(SelectedSoftwareChangeDispatcher.EVENT_TYPE, this.setIsAutoSoftwareIsSelected);

    this.setIsAutoSoftwareIsSelected();
  },
}
</script>

